export default __webpack_public_path__ + "static/gravitywell-cover-6162086609ed6202ac7f64b300a8e38b.jpg";